import $ from 'jquery';

var Basket = {
    init: function () {
        this.eventHandler();
        this.returnToPrevUrlWithPositionHandler();
    },
    updateProcess: false,
    lastProductForm: null,

    eventHandler: function () {
        this.addProduct();
        this.fastAddProduct();
        this.fastDeleteProduct();
        this.fastUpdateForm()
    },

    fastUpdateForm: function() {
        $('body').on('keyup', 'input.update-form-input', function() {
            let el = this;
            if (this.updateProcess !== false) {
                clearTimeout(this.updateProcess);
                this.updateProcess = false;
            }

            this.updateProcess = setTimeout( function() {
                $(el).closest('form').submit();
            }, 500);
        });
        $('body').on('change', 'select.update-form-select', function() {
            $(this).closest('form').submit();
        });

    },
    addProduct: function() {
        $('body').on('submit', 'form.add-to-basket-ajax', function(e) {
            e.preventDefault();
            Basket.lastProductForm = $(this);

            $.ajax({
                type: 'POST',
                data: $(this).serialize(),
                url: window.ajax.basket.checkOrderQuantityStep,
                beforeSend: function () {
                    Basket.clearMessages();
                },
                error: function (resp) {
                    console.log();
                },
                success: function (resp) {
                    console.log(resp);
                    if (resp.result) {
                        Basket.addProductAction();
                    } else {
                        $('#changeOrderQtyModal .modal-body').html(resp.html);
                        window.$('#changeOrderQtyModal').modal('show');
                    }
                }
            });

        });

        $('body').on('click', '#confirmChangeOrderQty', function(e) {

            Basket.addProductAction();

        });
    },

    addProductAction: function () {
        if (Basket.lastProductForm === null) return;
        let form = Basket.lastProductForm;
        Basket.lastProductForm = null;
        let currency = form.data('currency');
        let productName = form.data('product-name');
        let productId = form.data('product-id');
        let price = form.data('price');
        let quantity = form.find('input[name=quantity]').val();
        let category = form.data('category');
        let brand = form.data('brand');
        $.ajax({
            type: 'POST',
            data: form.serialize(),
            url: window.ajax.basket.addProductUrl,
            beforeSend: function () {
                Basket.clearMessages();
            },
            error: function (resp) {
                Basket.updateBasketHtml(resp);
            },
            success: function (resp) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'addToCart',
                    'ecommerce': {
                        'currencyCode': currency,
                        'add': {
                            'products': [{
                                'name': productName,
                                'id': productId,
                                'price': price,
                                'brand': brand,
                                'category': category,
                                'quantity': quantity
                            }]
                        }
                    }
                });
                Basket.updateBasketHtml(resp);
            }
        });
    },

    updateBasketHtml: function(data) {
        $('li.nav-item.dropdown.basket').html(data.basketHtml);
        $('span.basket__products-count-text').html(data.count);
        $('div.ajax-messages').html(data.message);
        setTimeout(function() {
            Basket.clearMessages();
        }, 5000);
    },

    fastAddProduct: function() {
        jQuery('select.products-select').select2({
            placeholder: {
                id: '-1', // the value of the option
                text: window.translations.pleaseSelectOptionText,
            },
            ajax: {
                url: window.ajax.products,
                dataType: 'json',
                delay: 500,
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page
                    };
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;

                    return {
                        results: data.items,
                        pagination: {
                            more: (params.page * 30) < data.total_count
                        }
                    };
                },
                cache: true
            },
            minimumInputLength: 2,
            language: { inputTooShort: function () { return window.translations.minimumCharsForSearch; } },
            dropdownPosition: 'below'
        }).on('select2:select', function (e) {
            $('.fast-order-change-quantity-order').html('');
            $.ajax({
                type: 'GET',
                url: window.ajax.basket.fastAddProductUrl + '?product_code=' + $('#choose-product').val(),
                error: function(resp) {

                },
                success: function(resp) {
                    /*if ($('tr#row-' + resp.product_code).length == 0) {
                        $('#fast-order-table tbody').append(resp.html);
                    }*/
                    if (resp.order_quantity_step !== false) {
                        $('.fast-order-change-quantity-order').html(resp.order_quantity_step);
                    }
                    fastOrderTable.ajax.reload(null, false).page('last').draw('page');
                }
            });
            if ($("select.products-select").length) $("select.products-select").empty();
        }).on('select2:open', function () {

        });
    },
    fastDeleteProduct: function() {
        $('body').on('click', 'a.fast-basket-delete-row', function(e) {
            e.preventDefault();
            var url = $(this).attr('href');
            //$(this).closest('tr').remove();
            $.ajax({
                type: 'GET',
                url: url,
                error: function(resp) {

                },
                success: function(resp) {
                    $('.fast-order-change-quantity-order').html('');
                    fastOrderTable.ajax.reload(null, false);
                }
            });
        });
    },

    clearMessages: function() {
        $('div.ajax-messages').html('');
    },

    returnToPrevUrlWithPositionHandler: function() {
        $('.btn--back-to-url').click(function() {
            var url = localStorage.getItem('lastGoodUrl');
            var offset = localStorage.getItem('lastGoodOffset') !== null ? parseFloat(localStorage.getItem('lastGoodOffset')) : 0;

            if (offset > 0) {
                localStorage.setItem('hasToScroll', "1");
            }

            if (url === null) {
                window.location.href = window.location.origin;
            } else {
                window.location.href = url;
            }

        });
    }
}

export default Basket;
